export default "__VITE_PUBLIC_ASSET__18de809c__"